import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/application/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/application/layouts/login.vue").then(m => m.default || m)),
  presentation: defineAsyncComponent(() => import("/application/layouts/presentation.vue").then(m => m.default || m)),
  "presentation-cart": defineAsyncComponent(() => import("/application/layouts/presentationCart.vue").then(m => m.default || m)),
  "presentation-preview": defineAsyncComponent(() => import("/application/layouts/presentationPreview.vue").then(m => m.default || m))
}